import * as React from "react"
import { date, version } from "../../version"

export const Version: React.FC = () => <span title={`${date}`}>{version}</span>
